module.exports = __webpack_public_path__ + "static/media/img1.d10189d8.jpg";